// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-7fb7e422]{overflow:hidden;border:1px solid rgba(128,128,128,.2)}", ""]);
// Exports
module.exports = exports;
